"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var DealerDetails_1 = require("./DealerDetails");
var DealerDetailsWrapper = function (_a) {
    var dealerDetails = _a.dealerDetails;
    var _b, _c, _d;
    if (!((_b = dealerDetails) === null || _b === void 0 ? void 0 : _b.label)) {
        return null;
    }
    return (<DealerDetails_1.default name={dealerDetails.label} streetName={(_c = dealerDetails.address) === null || _c === void 0 ? void 0 : _c.address} city={(_d = dealerDetails.address) === null || _d === void 0 ? void 0 : _d.city} postCode={dealerDetails.postCode}/>);
};
exports.default = DealerDetailsWrapper;
